import {AbstractRepository} from './AbstractRepository'
import 'core-js/es6/array';

export class BoxRepository extends AbstractRepository {
    box;

    constructor() {
        super();
        this.box = this.table('box');
    }

    findAll() {
        return new Promise(resolve => {
            this.transaction('rw', this.box, () => {
                this.box = this.box.toArray();
                resolve(this.box);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    findById(id) {
        return new Promise(resolve => {
            this.transaction('rw', this.box, () => {
                this.box = this.box.where("id").equals(parseInt(id)).toArray();
                resolve(this.box);
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    update(box, tabs) {

        return new Promise(resolve => {
            this.transaction('rw', this.box, () => {

                let thisRepository = this;
                tabs.forEach(function (box) {
                    thisRepository.box.update(box.id, {
                        color: box.color,
                        selected: box.selected,
                        dashboard: box.dashboard,
                        hidden: box.hidden,
                        title: box.title,
                        parent: box.parent,
                        active: false
                    });
                });

                resolve(this.box.update(box.id, {
                        color: box.color,
                        selected: box.selected,
                        dashboard: box.dashboard,
                        hidden: box.hidden,
                        title: box.title,
                        parent: box.parent,
                        active: box.active
                    }
                ));
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    add(type,title,parent,color,selected,dashboard,hidden) {
        return new Promise(resolve => {
            this.transaction('rw', this.box, async () => {
                let id = await this.box.add(
                    {
                        color: color,
                        selected: selected,
                        dashboard: dashboard,
                        hidden: hidden,
                        title: title,
                        parent: parent,
                        type: type,
                        active: false
                    }
                );
                resolve({
                    id: id,
                    color: color,
                    selected: selected,
                    dashboard: dashboard,
                    hidden: hidden,
                    title: title,
                    parent: parent,
                    type: type,
                    active: false
                });
            }).catch(e => {
                alert(e.stack || e);
            });
        });
    }

    remove(id) {
        this.transaction('rw', this.box, async() => {
            await this.box.where("id").equals(id).delete();
        }).catch(e => {
            alert(e.stack || e);
        });
    }
}
